<template>
  <div>
    <div id="map" style=""></div>
  </div>
</template>
<!-- 2020-07-25, java script secure key 사용시 에러 발생 -->
<!-- https://devtalk.kakao.com/t/api/56578 -->

<script>
export default {
  props: {
    addrX: {
      type: String,
      default: String
    },
    addrY: {
      type: String,
      default: String
    }
  },
  data() {
    return {
      map: null
    };
  },
  mounted() {
    const script = document.createElement("script");
    script.src = `https://dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=${process.env.VUE_APP_KAKAO_API_KEY}&libraries=services`;

    script.addEventListener("load", async () => {
      await kakao.maps.load(this.initMap);
    });
    // debugger;
    // script.addEventListener("load", () => {
    // });
    document.head.appendChild(script);
  },
  methods: {
    initMap() {
      const container = document.getElementById("map"); // 지도를 담을 영역의 DOM 레퍼런스

      if (!this.addrX && !this.addrY) {
        alert("aaa");
      }

      const center = new kakao.maps.LatLng(this.addrY, this.addrX);

      const options = {
        center,
        draggable: false,
        level: 5
      };
      const map = new kakao.maps.Map(container, options);

      const markerPosition = new kakao.maps.LatLng(this.addrY, this.addrX);
      // 마커를 생성합니다
      const marker = new kakao.maps.Marker({
        position: markerPosition
      });
      // 마커가 지도 위에 표시되도록 설정합니다
      marker.setMap(map);
    }
  }
};
</script>

<style>
#map {
  width: 100%;
  height: 165px;
  margin-bottom: 16px;
}
</style>
